import { ContactUrgency } from './ContactUrgency';
import { ContactAddress } from './ContactAddress';
import { ContactMethods } from './ContactMethods';

export const ContactSection = ({ handleWhatsAppClick, handleCallClick }) => (
<section id="contact" className="py-12 md:py-16 bg-black relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-10">
          <img 
            src="https://images.unsplash.com/photo-1761059724415-8f7b95da2dc0" 
            alt="Consultation marabout voyant" 
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <span className="inline-block bg-green-600/20 border border-green-600/40 text-green-400 px-6 py-2 rounded-full text-sm font-semibold mb-6">
                💬 Contact Rapide
              </span>
              <h2 className="text-4xl md:text-6xl font-bold mb-6 text-red-600">
                Contactez le Sorcier Vaudou Maître Diamma
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                Consultation urgente disponible maintenant • Réponse rapide garantie • Discrétion absolue
              </p>
            </div>

            <ContactMethods handleWhatsAppClick={handleWhatsAppClick} handleCallClick={handleCallClick} />

            <ContactAddress />

            <ContactUrgency handleWhatsAppClick={handleWhatsAppClick} />
          </div>
        </div>
      </section>
);
